import { render, staticRenderFns } from "./cartShow.vue?vue&type=template&id=4b8e510e&scoped=true"
import script from "./cartShow.vue?vue&type=script&lang=js"
export * from "./cartShow.vue?vue&type=script&lang=js"
import style0 from "./cartShow.vue?vue&type=style&index=0&id=4b8e510e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8e510e",
  null
  
)

export default component.exports